import { Reference } from '@apollo/client';
import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useDeleteCommunityPostMutation } from 'generated/graphql';
import { CommunityId } from '../model/community.types';
import { PostId } from '../model/post.types';

type DeletePostArgs = {
  communityId: CommunityId;
  postId: PostId;
};

export const useDeletePost = () => {
  const [deletePostMutation] = useDeleteCommunityPostMutation();

  return useCallback(
    ({ communityId, postId }: DeletePostArgs) =>
      deletePostMutation({
        variables: { communityId, postId },
        optimisticResponse: {
          __typename: 'Mutation',
          deletePost: { __typename: 'Post', id: postId },
        },
        update: (cache) => {
          cache.modify({
            id: cache.identify({ __typename: 'Community', id: communityId }),
            fields: {
              posts: (existing: readonly Reference[] = [], { readField }) =>
                existing.filter((ref) => readField('id', ref) !== postId),
            },
          });
        },
      })
        .then(() => {
          toast.success('Post deleted');
        })
        .catch(() => {
          toast.error('Something went wrong');
        }),
    [deletePostMutation],
  );
};
